<script setup lang="ts">
import { PowerUpLayout } from "@vendata/power-up-clients-common";
</script>

<template>
  <PowerUpLayout
    :logged-in="true"
    :disable-container="true"
    nav-appearance="app"
  >
    <router-view />
  </PowerUpLayout>
</template>

<style scoped></style>
